var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9345 16.0384C15.3353 14.094 16.293 11.957 16.293 9.79395C16.293 5.92796 13.159 2.79395 9.29297 2.79395C5.42698 2.79395 2.29297 5.92796 2.29297 9.79395C2.29297 11.957 3.25066 14.094 4.65143 16.0384C6.04165 17.9681 7.75107 19.5442 8.96987 20.5424C9.16977 20.7061 9.41617 20.7061 9.61607 20.5424C10.8349 19.5442 12.5443 17.9681 13.9345 16.0384ZM10.8834 22.0896C13.4676 19.973 18.293 15.2856 18.293 9.79395C18.293 4.82339 14.2636 0.793945 9.29297 0.793945C4.32241 0.793945 0.292969 4.82339 0.292969 9.79395C0.292969 15.2856 5.11834 19.973 7.70257 22.0896C8.63957 22.857 9.94637 22.857 10.8834 22.0896Z",
    fill: "#059669"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29296 7.79394C8.18836 7.79394 7.29297 8.68937 7.29297 9.79394C7.29297 10.8985 8.18836 11.7939 9.29296 11.7939C10.3976 11.7939 11.293 10.8985 11.293 9.79394C11.293 8.68937 10.3976 7.79394 9.29296 7.79394ZM5.29297 9.79394C5.29297 7.5848 7.08383 5.79395 9.29296 5.79395C11.5021 5.79395 13.293 7.5848 13.293 9.79394C13.293 12.003 11.5021 13.7939 9.29296 13.7939C7.08383 13.7939 5.29297 12.003 5.29297 9.79394Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLocationIcon);
export default __webpack_public_path__ + "static/media/web_Location_icon.bef8403ba2932de67ed1fad07c9b9614.svg";
export { ForwardRef as ReactComponent };